import { ApiEndpointClient } from './resource-client';
const VALUATION_API_PREFIX = 'valuation-api/v1';
export class AssetsClient extends ApiEndpointClient {
    http;
    constructor(http) {
        super(http, VALUATION_API_PREFIX);
        this.http = http;
    }
    getAllReportsLinkToZip = async ({ assetId, customerId }) => {
        return this.get(`/assets/${assetId}/asset-reports`, {
            query: customerId ? { customer_uuid: customerId } : undefined,
        });
    };
    getAllAssetValXMLsLinkToZip = async ({ assetId, customerId }) => {
        return this.get(`/assets/${assetId}/asset-valxmls`, {
            query: customerId ? { customer_uuid: customerId } : undefined,
        });
    };
    createAsset = async (asset) => {
        return this.post('/assets/', { json: asset });
    };
    getAsset = async ({ assetId, orderId, customerId, }) => {
        const query = {};
        if (orderId)
            query.order_uuid = orderId;
        if (customerId)
            query.customer_uuid = customerId;
        return this.get(`/assets/${assetId}`, { query });
    };
    getAssets = async (options) => {
        return this.get('/assets/', {
            query: options?.customerId ? { customer_uuid: options.customerId } : undefined,
        });
    };
    deleteAsset = async ({ assetId, deleteReason }) => {
        await this.delete(`/assets/${assetId}`, { json: { delete_reason: deleteReason }, response: 'raw' });
    };
    patchAsset = async ({ assetId, orderId, operations, }) => {
        await this.patch(`/assets/${assetId}`, {
            query: orderId ? { order_uuid: orderId } : undefined,
            json: operations,
            response: 'raw',
        });
    };
    uploadAssetImage = async ({ assetId, image }) => {
        const formData = new FormData();
        formData.append('file', image);
        await this.post(`/assets/${assetId}/images`, { body: formData, response: 'raw' });
    };
    getAssetEnergySummary = async ({ assetId, customerId }) => {
        return this.get(`/assets/${assetId}/energy-summary`, {
            query: customerId ? { customer_uuid: customerId } : undefined,
        });
    };
    getSingleAssetValueOverview = async ({ assetId, valuationId, customerId, }) => {
        return this.get(`/assets/${assetId}/value-overview`, {
            query: {
                ...(valuationId ? { reference_valuation_uuid: valuationId } : {}),
                ...(customerId ? { customer_uuid: customerId } : {}),
            },
        });
    };
    getMultiAssetValueOverview = async ({ assetIds, customerId, } = {}) => {
        return this.get('/assets/value-overview', {
            query: {
                ...(assetIds && assetIds.length > 0 ? { assets: assetIds.join(',') } : {}),
                ...(customerId ? { customer_uuid: customerId } : {}),
            },
        });
    };
}
